import { WidgetPage } from '@/common/model/recommend/widgetPage'

import SimpleTable from '@/components/view/atoms/table/SimpleTable'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import WidgetPageListRow from '@/components/container/modules/recommend/widgetPage/table/WidgetPageListRow'

interface Props {
  widgetPages: WidgetPage[]
  onRefresh: () => void
}

const WidgetPageListTable = ({ widgetPages, onRefresh }: Props) => {
  return (
    <SimpleTable>
      <thead>
        <TableRow head>
          <TableRowItem width={320}>
            <Text size={12} color={TextColor.SECONDARY}>
              レコメンドパーツ設置ページ名
            </Text>
          </TableRowItem>
          <TableRowItem>
            <Text size={12} color={TextColor.SECONDARY}>
              ページURL
            </Text>
          </TableRowItem>
          <TableRowItem width={64}>{null}</TableRowItem>
        </TableRow>
      </thead>
      <tbody>
        {widgetPages.map((widgetPage) => (
          <WidgetPageListRow key={widgetPage.id} widgetPage={widgetPage} onRefresh={onRefresh} />
        ))}
      </tbody>
    </SimpleTable>
  )
}

export default WidgetPageListTable
